import React, { useEffect, useState } from "react";
import AWS from "aws-sdk/global";
import S3 from "aws-sdk/clients/s3";
import $ from "jquery";
import { withRouter } from "react-router-dom";

const ImageUpload = (props) => {
  const [item, setItem] = useState("");
  const bucketname = "js-sdk-bucket";
  AWS.config.region = "ap-south-1"; // Region
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: "ap-south-1:84027705-475d-4ca1-bac8-b2eb7407ae9f",
  });
  const bucket = new AWS.S3({
    params: {
      Bucket: bucketname,
    },
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [filesError, setFilesError] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);

  const { id } = props.match.params;

  useEffect(() => {
    if (id) {
      uploadDetail(id);
    }
  }, [id]);

  const uploadDetail = (id) => {
    setIsUpdate(true);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `https://dwltnlb3hto3i.cloudfront.net/v1/banner/detail?id=${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result.response.banner_path, "item");
        if (
          result &&
          result["resultFlag"] == "1" &&
          result["resultFlag"] == 1
        ) {
          if (result.response.banner_path) {
            setUploadImage(result.response.banner_path);
          }
        }
      })
      .catch((error) => console.log("error", error));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const handleUpload = () => {
    // Implement your image upload logic here
    if (selectedImage) {
      // Assuming you want to perform some action with the selected image
      console.log("Uploading image:", selectedImage["name"]);
      uploadToS3(
        selectedImage,
        `vocalforlocal/banner/${selectedImage["name"]}`,
        () => SaveData(`vocalforlocal/banner/${selectedImage["name"]}`),
        ""
      );
    } else {
      console.log("No image selected");
    }
  };

  const uploadToS3 = async (
    file,
    fileKey,
    callback,
    mode = "profile_image"
  ) => {
    let i = document.getElementById("loaderdefault");
    if (i) {
      i.style.display = "block";
    }
    var sessionid = Date.now();
    var originalKey = fileKey
      ? fileKey
      : `vocal_for_local/${mode}/${mode}_${sessionid}.jpg`;
    var params = {
      Key: originalKey,
      ContentType: file && file.type ? file.type : "image/jpeg",
      Body: file,
      ACL: "public-read",
    };
    if (!callback) {
      callback = (err, data) => {};
    }
    // bucket.putObject(params, callback(originalKey));
    bucket.putObject(params, callback);
    if (i) {
      i.style.display = "none";
    }
  };

  const SaveData = (filekey) => {
    var ref = this;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      path: "https://nm-seva-photos.b-cdn.net/" + filekey,
      id: id ? id : "",
    });
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch(
      "https://dwltnlb3hto3i.cloudfront.net/v1/banner/addandupdate",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result && result["resultFlag"] == 1) {
          alert("Image Uploaded Successfully");
          props.history.push(`/vocalforlocal/uploadlist`);
        }
      })
      .catch((error) => console.log("error", error));
  };
  return (
    <div className="wrapper wrapper-content animated fadeInRight">
      <div className="row">
        <div className="col-lg-12">
          <div className="ibox float-e-margins">
            <div className="ibox-content">
              <div className="row">
                {/* <div className="col-sm-12 b-r final_form"> */}
                <div className="col-sm-12">
                  <form
                    method="post"
                    className="form-horizontal "
                    id="uploadCategory"
                  >
                    <div className="col-sm-8">
                      <div className="">
                        <h3 className="tweet_head">
                          {isUpdate ? "Update Image" : "Add Image"}
                        </h3>

                        <div className="row my-3">
                          <div className="col-sm-3">
                            <label htmlFor="floatingTextarea">
                              Select Image<span className="error_p">*</span>
                            </label>
                          </div>

                          <div className="col-sm-9">
                            <div className="imgup_div">
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                              />
                              <ul className="image_list">
                                <li>
                                  <h5>Image Upload</h5>
                                </li>
                                <li>
                                  <h6>
                                    <span className="fa fa-upload"></span>
                                  </h6>
                                </li>
                              </ul>
                            </div>
                            {filesError && (
                              <p className="error_p">Please select images</p>
                            )}

                            <button
                              className="btn btn-sm btn-primary btn_twwetadd"
                              type="button"
                              onClick={handleUpload}
                            >
                              <strong>{isUpdate ? "Update" : "Add"}</strong>
                            </button>
                            {selectedImage ? (
                              <div>
                                <h5 className="img_name_preview">
                                  Selected Image
                                </h5>
                                <img
                                  src={URL.createObjectURL(selectedImage)}
                                  alt="Selected"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "200px",
                                  }}
                                />
                              </div>
                            ) : (
                              <div>
                                <h5 className="img_name_preview">
                                  Uploaded Image
                                </h5>
                                <img
                                  src={uploadImage}
                                  alt="Selected"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "200px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ImageUpload);



// WEBPACK FOOTER //
// ./src/Components/VocalForLocal/ImageUpload.jsx